import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Text } from "components";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { BsDownload } from "react-icons/bs";
import { FaRegEdit } from "react-icons/fa";
import actionbuttonCustomStyle, {
  CustomOption,
} from "styles/actionbuttonCustomStyle.";
import { IoMdDownload } from "react-icons/io";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const OperationDocumentList = forwardRef((props, ref) => {
  const { id } = useParams();
  console.log("id", id);
  let navigate = useNavigate();
  const [operationdocument, setOperationdocument] = useState([]);
  const gridRef = useRef();
  const selectRef = useRef();

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
    PurchaseOrderGet();
  }, []);

  const [erplist, setErplist] = useState([]);
  const name = sessionStorage.getItem("name");
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      downloadExcel: () => {
        onBtnExport();
      },

      downloadPdf: () => {
        DownloadPDF();
      },
    }),
    []
  );

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 11 && item.update
  );

  const handleFormSubmit = async (values, opName) => {
    try {
      const requestData = {
        id: values,
      };
      console.log(requestData);

      const response = await axios.post(
        "/api/purple-fusion/operationdocument/downloads",
        requestData,
        {
          ...headers,
          responseType: "arraybuffer",
        }
      );

      const contentDisposition = response.headers["content-disposition"];
      const contentType = response.headers["content-type"];

      // Extract file name and extension from content disposition
      const fileNameMatch = contentDisposition.match(
        /filename=["']?([^'"\s]+)["']?/
      );
      const fileName = fileNameMatch ? fileNameMatch[1] : "download";
      const fileExtension = fileName.split(".").pop();

      // Sanitize the opName by removing special characters
      const sanitizedOpName = opName.replace(/[^a-zA-Z0-9]/g, "");

      // Store the first 50 characters of the sanitized name
      const truncatedOpName = sanitizedOpName.substring(0, 50);

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: contentType });

      // Check if the Blob type is supported before creating an Object URL
      if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
        const arrayBuffer = await blob.arrayBuffer();
        const url = window.URL.createObjectURL(new Blob([arrayBuffer]));

        // Open a new tab and set its location to the Object URL
        // window.open(url);

        const a = document.createElement("a");
        a.href = url;
        let lastIndex = fileExtension.lastIndexOf("/");
        a.download = `${truncatedOpName}.${fileExtension.substr(
          lastIndex + 1
        )}`;
        document.body.appendChild(a);

        // Trigger a click event to start the download
        a.click();

        // Remove the download link from the DOM
        document.body.removeChild(a);

        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } else {
        console.error(
          "Blob.arrayBuffer is not supported. Unable to create Object URL."
        );
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const sortedoperationdocument = operationdocument
    .slice()
    .sort((a, b) => b.id - a.id);

  const DownloadPDF = () => {
    const docDefinition = {
      pageOrientation: "portrait",
      header: {
        text: "Opeartion Documents ",
        style: "header",
      },
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                [{ text: "SNO.", style: "tableHeader", bold: true }],
                [{ text: "OPERATION NAME", style: "tableHeader", bold: true }],
                [{ text: "DOCUMENT NAME ", style: "tableHeader", bold: true }],
                [{ text: "ACTIVE", style: "tableHeader", bold: true }],

                [{ text: "CREATED DATE", style: "tableHeader", bold: true }],
              ],
              ...sortedoperationdocument.map((operationdocument, index) => [
                index + 1,
                operationdocument.operationname,
                operationdocument.operation_document_name,
                operationdocument.isactive ? "Yes" : "No",
                operationdocument.createdon.substr(0, 10),
              ]),
            ],
            widths: "auto",
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
          color: "#000",
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
          // Add underline
          color: "#333",
        },
      },
    };
    pdfMake.createPdf(docDefinition).download("Operation Documents list");
  };

  const onBtnExport = useCallback(() => {
    const columnsToExport = [
      "sr",
      "operationname",
      "operation_document_name",
      "createdon",
      "isactive",
    ];

    const exportColumns = customColDefs.filter((column) =>
      columnsToExport.includes(column.field)
    );
    const options = {
      fileName: "Operation Document List.csv", // Specify your desired filename here
      columnKeys: exportColumns.map((column) => column.field), // Specify the column field to export
    };
    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const handleNavigation = (option) => {
    console.log("Navigate to:", option.value);
    const params = option.params;

    switch (option.value) {
      case "Download":
        handleFormSubmit(params.data.id, params.data.operationname);
        break;

      case "Edit":
        navigate(`/operationdocument/edit/${params.data.id}/${id}`);
        break;

      default:
        console.error("Unknown action:", option.value);
        break;
    }
  };

  const OperationnDocument_Obj = { operation_id: id };
  const PurchaseOrderGet = () => {
    axios
      .post(
        "/api/purple-fusion/operationdocument/get",
        OperationnDocument_Obj,
        headers
      )
      .then((response) => {
        if (response.data.length < 1) {
          // document.getElementById("progrss-bar-id").style.visibility = "hidden";
          document.getElementById("progress-bar-id").innerHTML =
            "No record found.";
        } else {
          setOperationdocument(response.data);
        }
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updatedActionButtonCustomStyle = {
    ...actionbuttonCustomStyle,
    menu: (base) => ({
      ...base,
      marginTop: "0px", // Change the marginTop as needed
      marginRight: "100px", // Change the marginRight as needed
      marginBottom: "0", // Change the marginBottom as needed
      marginLeft: "0px", // Change the marginLeft as needed
      paddingTop: "0", // Change the paddingTop as needed
      paddingRight: "0", // Change the paddingRight as needed
      paddingBottom: "0", // Change the paddingBottom as needed
      paddingLeft: "0", // Change the paddingLeft as needed
      zIndex: 9999, // Keep the existing zIndex or modify as needed
    }),
  };

  const defaultColDefs = [
    // { headerName: "Sr.No", field: "id", width: 150 },
    { headerName: "SNO.", field: "sr", width: 85, bold: true },
    { headerName: "OPERATION NAME", field: "operationname", width: 280 },
    {
      headerName: "DOCUMENT NAME",
      field: "operation_document_name",
      width: 250,
    },
    {
      headerName: "ACTIVE",
      field: "isactive",
      width: 130,
      valueFormatter: (params) => {
        return params.value ? "Yes" : "No";
      },
    },

    {
      headerName: "CREATED DATE",
      field: "createdon",
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
      width: 280,
    },

    {
      headerName: "",
      field: "id",
      filter: false,
      sortable: false, // Disable sorting for this column
      width: 10,

      tooltipField: "Download", // Tooltip for the entire cell
      cellRenderer: (params) => (
        <button
          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          onClick={() =>
            handleFormSubmit(params.value, params.data.operationname)
          }
          title="Download" // Tooltip on hover
        >
          <BsDownload className="text-base" />
        </button>
      ),
    },
    {
      headerName: "ACTION",
      field: "operationname",
      pinned: "right",
      cellRenderer: (params) => {
        const getOptions = () => {
          let options = [
            {
              value: "Download",
              label: "Download",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: IoMdDownload,
              params: params,
            },
          ];
          if (showActionColumn) {
            options.push({
              value: "Edit",
              label: "Edit",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: FaRegEdit,
              params: params,
            });
          }
          return options;
        };

        const options = getOptions();

        return (
          <div style={{ width: "100%", position: "relative", zIndex: 999 }}>
            <Select
              options={options}
              isSearchable={false}
              onChange={handleNavigation}
              placeholder={params.value || "ACTION"}
              menuPlacement="bottom"
              menuPortalTarget={selectRef.current} // Render the menu in the body
              // styles={updatedActionButtonCustomStyle}
              styles={updatedActionButtonCustomStyle}
              value={null} // Ensure no value is selected
              components={{ Option: CustomOption }} // Use the custom option component
            />
          </div>
        );
      },
      width: 150,
    },
  ];

  const customColDefs = [
    ...defaultColDefs,
    {
      headerName: "",
      filter: false,
      field: "id",
      tooltipField: "Edit",
      cellRenderer: (params) => (
        <Link
          to={`/operationdocument/edit/${params.value}/${id}`}
          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          title="Edit"
        >
          <button>
            {" "}
            <FaRegEdit />
          </button>
        </Link>
      ),
      width: 50,
    },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(showActionColumn ? customColDefs : defaultColDefs);
  }, [showActionColumn]);
  const ColDefaultVale = { filter: true };

  const gridOptions = {
    overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
  };
  return (
    <>
      {erplist.some((item) => item.erp_module_id === 11 && item.view) ? (
        <div className="overflow-hidden">
          <div
            className="ag-theme-quartz"
            // style={{ height: 550, width: "100%", fontSize: "12px" }}
            id="tab-grid-table"
            ref={selectRef}
          >
            <AgGridReact
              ref={gridRef}
              rowData={sortedoperationdocument.map(
                (operationdocument, index) => ({
                  ...operationdocument,
                  sr: index + 1,
                })
              )}
              columnDefs={colDefs}
              pagination={true}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              gridOptions={gridOptions}
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
});

export default OperationDocumentList;
